"use strict";

class ResponsiveScribdDocumentView extends Backbone.View {
  initialize(opts) {
    this.zoomPerPixel = null;
    this.ui = {
      $loader: this.$(".js-scribd-document-loader"),
      $container: this.$(".js-scribd-document-container")
    };
    this._throttledCheckForPageChange = _.throttle(() => this._checkForPageChange(), 250);
    this.tracker = new ScribdDocumentTracker(opts.attachmentId, this);
    this.logged_in_user = opts.isLoggedIn;
    this.work = opts.work || {};
    if (this.logged_in_user) {
      this.label = "Swp_LoggedIn";
      this.shouldShowBulkDownload = opts.shouldShowBulkDownload;
    } else {
      this.label = "Swp_LoggedOut";
    }
    this.currentScroll = 0;
    this.attachmentId = opts.attachmentId;
    return this.shouldShowInterstitialRelatedWorks = opts.shouldShowInterstitialRelatedWorks || false;
  }
  show() {
    this.ui.$loader.show();
    this.ui.$container.append("<div id='scribd-reflowable-doc'></div>");
    this.scribdDoc = this._getDoc();
    this.scribdDoc.addEventListener("docReady", e => this._onDocReady(e));
    $(window).on(`scroll.scribd-${this.attachmentId}`, () => this._throttledCheckForPageChange());
  }
  tear_down() {
    this.scribdDoc.__remove();
    this.scribdDoc = null;
    return $(window).off(`scroll.scribd-${this.attachmentId}`);
  }
  _resizeScribd() {
    if (this.scribdDoc != null) {
      this.trigger("beforeResize");
      const calculatedZoom = this.zoomPerPixel * this._calculateWidth();
      this.scribdDoc.api.setZoom(calculatedZoom);
      return this.trigger("afterResize");
    }
  }
  _calculateWidth() {
    const docWidth = this.$("#scribd-reflowable-doc").outerWidth();
    window.$a.log("scribd document width: ", docWidth);
    return docWidth;
  }
  _onDocReady(e) {
    this.ui.$loader.hide();
    const initialScribdWidth = this.$(".outer_page:first").width();
    this.zoomPerPixel = 1 / initialScribdWidth;
    this._resizeScribd();
    window.addEventListener("resize", () => this._resizeScribd());
    this.trigger("docReady", e);
    window.dispatchEvent(new Event("scribdDocReady"));
    window.dispatchEvent(new Event("scribdLoadingEnded"));
  }
  _getDoc() {
    const scribdDoc = scribd.Document.getDoc(this.attachmentId);
    scribdDoc.addParam("jsapi_version", 2);
    scribdDoc.addParam("disable_related_docs", true);
    scribdDoc.addParam("disable_resume_reading", true);
    scribdDoc.addParam("hideZoomControls", true);
    scribdDoc.seamless("scribd-reflowable-doc");
    return scribdDoc;
  }
  _checkForPageChange() {
    if (!this.scribdDoc) {
      return;
    }
    const page = this.getPage();
    window.maxScribdPage = Math.max(page, window.maxScribdPage || 0);
    if (this.currentPage !== page) {
      window.$a.log(`Scribd page: ${page}, was: ${this.currentPage}`);
      this.trigger("pageChanged", {
        was: this.currentPage,
        page
      });
      return this.currentPage = page;
    }
  }
  // Would be cool if we could use the Scribd API for this, but it doesn't work,
  // despite the docs
  getPage(boundingElement) {
    if (boundingElement == null) {
      boundingElement = document;
    }
    let page = 0;
    _.each($('[id^="outer_page_"]'), pageTop => {
      if ($(pageTop).offset().top < $(document).scrollTop()) {
        return page++;
      }
    });
    return page;
  }
  // Returns a percent from 0 - 100 for the current scroll progress through the entire document
  _getScrollPercent() {
    const doc = document.documentElement;
    const {
      body
    } = document;
    const st = "scrollTop";
    const sh = "scrollHeight";
    return (doc[st] || body[st]) / ((doc[sh] || body[sh]) - doc.clientHeight) * 100;
  }
}
if (window.Aedu) {
  Aedu.ResponsiveScribdDocumentView = ResponsiveScribdDocumentView;
}
window.ResponsiveScribdDocumentView = ResponsiveScribdDocumentView;